import type { NamespaceSchema } from './types';

// Price-bidding knobs. Read by apps/api core/bid/settings.ts loadBidSettings()
// from the 'bid-settings' platform-config namespace. Drives the bid-window
// resolver: how long fleets have to bid, the revised-price cap, and whether
// the winning bid auto-commits or waits for an admin to approve one.

export const bidSettings: NamespaceSchema = {
  namespace: 'bid-settings',
  label: 'Bidding',
  description:
    'How paid bookings are matched. "Send to admin email" notifies an admin to price/match it manually (no bidding). "Broadcast to crews" invites the competing crew to bid via a 1-day link. Window + auto-commit settings only apply when broadcasting.',
  sections: [
    {
      label: 'Dispatch',
      fields: [
        {
          kind: 'select',
          key: 'dispatchMode',
          label: 'On payment, do this',
          default: 'admin',
          options: [
            { value: 'admin', label: 'Send to admin email (manual match)' },
            { value: 'broadcast', label: 'Broadcast to crews (price bidding)' },
          ],
        },
      ],
    },
    {
      label: 'Bid window',
      fields: [
        { kind: 'number', key: 'bidWindowSeconds', label: 'Bid window (seconds)', default: 300, min: 30, step: 30 },
        { kind: 'number', key: 'revisedPriceMaxUpliftPct', label: 'Max revised-price uplift (0.5 = 50%)', default: 0.5, min: 0, step: 0.05 },
      ],
    },
    {
      label: 'Resolution',
      fields: [
        {
          kind: 'boolean',
          key: 'autoCommit',
          label: 'Auto-commit winning bid (off = admin approves a bid)',
          default: true,
        },
      ],
    },
  ],
};
